module.exports = require("./it-VA.d.ts");